import { fn } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismInput, PrismSelectInput } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import GeneralFormFieldsCancelAndConfirm from 'lumen/components/general/form-fields/cancel-and-confirm';
import dayjsFormat from 'lumen/helpers/dayjs-format';

const META_SOURCES = [
  { id: 'tripadvisor', name: 'Tripadvisor' },
  { id: 'trivago', name: 'Trivago' },
  { id: 'googlehotelfinder', name: 'Google' },
];

interface ParityParityManagerMetaRateFormSignature {
  Args: {
    back: unknown;
    currencyCode: unknown;
    issue: unknown;
    next: unknown;
    setIssueProperty: unknown;
    setIssuePropertyFromEvent: unknown;
  };
}

export default class ParityParityManagerMetaRateForm extends Component<ParityParityManagerMetaRateFormSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isFormValid() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.issueMetaSource && this.isMetaRateValid;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isMetaRateValid() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      this.issueBaseRate &&
      this.issueMetaRate &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      parseFloat(this.issueMetaRate) > 0 &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
      parseFloat(this.issueMetaRate) < parseFloat(this.issueBaseRate)
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get issueBaseRate() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.issue?.base_rate;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get issueMetaRate() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.issue?.meta_rate;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get issueMetaSource() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.issue?.metasearch_channel;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get metaSourceOptions() {
    return META_SOURCES.map((metaSource) => ({
      label: metaSource.name,
      metaSource,
    }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get metaSourceValue() {
    return this.metaSourceOptions.find(
      (option) => option.metaSource === this.issueMetaSource,
    );
  }

  @action
  // @ts-expect-error: Incorrect type
  handleMetaSourceChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('metasearch_channel', option.metaSource);
  }

  <template>
    <div class="pt-400 pr-500 pb-800 pl-500" id="add-issue-form">
      <h2 class="header-title">{{t "parity_manager.add_issue.meta_info"}}</h2>
      <div class="mt-400 flex w-full flex-col">
        <label class="input-label required-indicator">
          {{t "parity_manager.meta_source"}}
        </label>
        <PrismSelectInput
          @onChange={{this.handleMetaSourceChange}}
          @options={{this.metaSourceOptions}}
          @placeholder={{t "general.dropdown.meta_search"}}
          @value={{this.metaSourceValue}}
        />
      </div>

      <div class="mt-400 flex w-full flex-col">
        <PrismInput
          @errorMessage={{t "parity_manager.validation.channel_rate"}}
          @hasErrors={{not this.isMetaRateValid}}
          {{! @glint-expect-error: Incorrect type }}
          @inlineLabel={{@currencyCode}}
          @label={{t "parity_manager.meta_rate"}}
          {{! @glint-expect-error: Incorrect type }}
          @onInput={{fn @setIssuePropertyFromEvent "meta_rate"}}
          @required={{true}}
          @requiredErrorMessage={{t "general.required"}}
          {{! @glint-expect-error: Incorrect type }}
          @value={{@issue.meta_rate}}
        />
      </div>

      <div class="flex w-full flex-col">
        <PrismInput
          @label={{t "parity_manager.meta_room_name"}}
          {{! @glint-expect-error: Incorrect type }}
          @onInput={{fn @setIssuePropertyFromEvent "meta_room_name"}}
          {{! @glint-expect-error: Incorrect type }}
          @value={{@issue.meta_room_name}}
        />
      </div>

      <div class="flex flex-row">
        <div class="flex w-1/2 flex-col pr-400">
          <label class="input-label required-indicator">{{t
              "general.arrival_date"
            }}</label>
          <PrismInput
            @disabled={{true}}
            @type="text"
            {{! @glint-expect-error: Incorrect type }}
            @value={{dayjsFormat @issue.arrival_date format="MM/DD/YYYY"}}
          />
        </div>
        <div class="flex w-1/2 flex-col">
          <label class="input-label required-indicator">{{t
              "rates.los"
            }}</label>
          {{! @glint-expect-error: Incorrect type }}
          <PrismInput @disabled={{true}} @type="text" @value={{@issue.los}} />
        </div>
      </div>
    </div>
    <div class="settings-modal__footer flex flex-row justify-end">
      <GeneralFormFieldsCancelAndConfirm
        {{! @glint-expect-error: Incorrect type }}
        @cancel={{@back}}
        @cancelText={{t "general.back"}}
        {{! @glint-expect-error: Incorrect type }}
        @confirm={{@next}}
        @confirmText={{t "general.next_step"}}
        @isConfirmDisabled={{not this.isFormValid}}
      />
    </div>
  </template>
}
